import React, { useState, useMemo } from 'react';
import { FileText, Download, ArrowUpDown, ChevronDown, ChevronUp, Loader } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const PdfArjacheNamune = () => {
  const { language } = useLanguage();
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 40;

  // The sample list of applications seen in the image
  const initialData = [
    { id: 1, name: 'पुण्यश्लोक अहिल्यादेवी पुरस्कार 2025 अर्ज व प्रसिद्धीपत्र संचिका' },
    { id: 2, name: 'जन्म मृत्यू अनुपलब्धता अर्ज व प्रस्ताव' },
    { id: 3, name: 'लोकसेवा अर्ज' },
    { id: 4, name: 'बेबाकी प्रमाणपत्रासाठी करावयाचा अर्ज' },
    { id: 5, name: 'बांधकाम परवाणगी अर्ज up to 150 SQM - APPENDIX-K1' },
    { id: 6, name: 'फेरफार अर्ज' },
    { id: 7, name: 'नाहरकत प्रमाणपत्रासाठी करावयाचा अर्ज' },
    { id: 8, name: 'नळ जोडणी अर्ज' },
    { id: 9, name: 'नमुना नं.8 वरील नोंदपती पती-पत्नी संयुक्त नावे करण्यासाठी अर्ज' },
    { id: 10, name: 'जॉबकार्ड नोंदणी फॉर्म' },
    { id: 11, name: 'ग्रामविद्युत व्यवस्थापक पदासाठी विनंती अर्ज' },
    { id: 12, name: 'ग्रामरक्षक दलाची स्थापना अर्जाचा नमुना' },
    { id: 13, name: 'आशा स्वयंसेविका पदासाठी अर्जाचा नमुना' },
    { id: 14, name: 'दिव्यांग (अपंग) लाभ अर्ज.' },
    { id: 15, name: 'अंत्यविधी प्रमाणपत्रासाठी करावयाचा अर्ज व प्रमाणपत्र' },
    { id: 16, name: 'MGNREGA- फळबाग फुलपिके वृक्ष लागवड अर्ज' },
    { id: 17, name: 'MGNREGA- काममागणी अर्ज - नमुना 4' },
    { id: 18, name: 'मुख्यमंत्री तीर्थ दर्शन योजना- अर्ज नमुना' },
    { id: 19, name: 'मुख्यमंत्री वयोश्री योजना- अर्ज नमूना' },
    { id: 20, name: 'मुख्यमंत्री \'माझी लाडकी बहिण\' योजना अर्ज Updated' },
    { id: 21, name: 'दिव्यांग लाभ योजना अर्जाचे नमुने - सांगली जिल्हा' },
    { id: 22, name: 'दिव्यांग घरकुल अर्ज नमुना - जिल्हा सांगली' },
    { id: 23, name: 'पुण्यश्लोक अहिल्यादेवी होळकर घरकुल योजना अर्ज - पं.स. पंढरपूर' },
    { id: 24, name: 'लेक लाडकी योजना अर्ज' },
    { id: 25, name: 'शबरी आवास घरकुल योजना अर्ज New' },
    { id: 26, name: 'MGNREGA- रेशीम उद्योग विकास योजना अर्ज' },
    { id: 27, name: 'दिव्यांग कल्याण विभाग दिव्यांगांच्या दारी अभियान अर्ज - नांदेड' },
    { id: 28, name: 'अटल भूजल योजना समृद्ध ग्राम स्पर्धा निबंध अर्ज (form)' },
    { id: 29, name: 'पुण्यश्लोक अहिल्यादेवी होळकर महिला सन्मान पुरस्कारासाठी अर्जाचा नमुना pdf' },
    { id: 30, name: 'MGNREGA सिंचन विहीर अर्ज.pdf (नवीन)' },
    { id: 31, name: 'सार्वजनिक गणेशोत्सव मंडळांना पुरस्कार - अर्ज नमुना' },
    { id: 32, name: 'वृक्षलागवड- रोप मागणी अर्ज' },
    { id: 33, name: 'ऊसतोड कामगार अर्ज व प्रमाणपत्र नमुना' },
    { id: 34, name: 'PMAY-Aadhar update form' },
    { id: 35, name: 'कन्या वन समृद्धी योजना अर्ज' },
    { id: 36, name: 'रजेसाठी किंवा रजावाढीसाठी अर्ज' },
    { id: 37, name: 'विवाह नोंदणी अर्ज' },
    { id: 38, name: 'विवाह नोंदणी ALL' },
    { id: 39, name: 'प्रशासकीय/विनंती बदली अर्ज' },
    { id: 40, name: 'DCPS-NPS सानुग्रह अनुदान अर्ज' },
  ];

  const [generatingId, setGeneratingId] = useState(null);

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const filteredData = useMemo(() => {
    let sortableItems = [...initialData];

    if (searchTerm) {
      sortableItems = sortableItems.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        item.id.toString().includes(searchTerm)
      );
    }

    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableItems;
  }, [initialData, searchTerm, sortConfig]);

  // Pagination logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) {
      return <ArrowUpDown className="w-4 h-4 text-gray-300 ml-1 inline" />;
    }
    return sortConfig.direction === 'ascending' 
      ? <ChevronUp className="w-4 h-4 text-gray-500 ml-1 inline" /> 
      : <ChevronDown className="w-4 h-4 text-gray-500 ml-1 inline" />;
  };

  const generatePDF = async (item) => {
    // If it's the Ahilyadevi form (id: 1)
    if (item.id === 1) {
      window.open('/ahilyadevi-form', '_blank');
      return;
    }
    
    // If it's Lokseva Arj form (id: 3)
    if (item.id === 3) {
      window.open('/lokseva-arj-form', '_blank');
      return;
    }

    // If it's Bebaki Pramanpatra Form (id: 4)
    if (item.id === 4) {
      window.open('/bebaki-pramanpatra-form', '_blank');
      return;
    }

    // If it's Pherphar Arj Form (id: 6)
    if (item.id === 6) {
      window.open('/pherphar-arj-form', '_blank');
      return;
    }

    // If it's Naharakat Arj Form (id: 7)
    if (item.id === 7) {
      window.open('/naharakat-arj-form', '_blank');
      return;
    }

    // If it's Nal Jodani Arj Form (id: 8)
    if (item.id === 8) {
      window.open('/nal-jodani-arj-form', '_blank');
      return;
    }

    // If it's Namuna 8 Sanyukt Arj Form (id: 9)
    if (item.id === 9) {
      window.open('/namuna8-sanyukt-arj-form', '_blank');
      return;
    }

    // For other forms, just show an alert currently since we haven't built them
    alert(language === 'marathi' ? `${item.name} फॉर्म लवकरच उपलब्ध होईल!` : `${item.name} form will be available soon!`);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col font-sans">
      <main className="flex-grow py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Main Card Container */}
          <div className="bg-white shadow-xl rounded-lg border border-gray-200 overflow-hidden">
            
            {/* Header Title Bar */}
            <div className="bg-[#fff1c9] border-b border-[#e5d4a1] py-2 px-4 flex justify-between items-center gap-2">
              <h2 className="text-[#000080] text-[15px] sm:text-xl font-bold flex items-center ">
            <span className="mr-2 text-2xl leading-none">&bull;</span> {language === 'marathi' ? 'अर्जाचे नमुने' : 'Application Forms'}
          </h2>
          <button onClick={() => window.history.back()} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print whitespace-nowrap shrink-0">
                  {language === 'marathi' ? 'मागे जा' : 'Back'}
                </button>
            </div>

            {/* Search Bar */}
            <div className="flex justify-end bg-white py-3 px-4 border-b border-gray-200">
              <div className="flex items-center">
                <label className="text-gray-600 mr-2 text-sm font-medium">Search:</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400 w-48"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1); // Reset page on search
                  }}
                />
              </div>
            </div>

            {/* Table Container for responsiveness */}
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse min-w-[700px]">
                <thead>
                  <tr className="bg-[#fdfdfd] border-b-2 border-gray-200 shadow-sm">
                    <th 
                      className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm cursor-pointer hover:bg-gray-50 transition-colors whitespace-nowrap"
                      onClick={() => handleSort('id')}
                      style={{ width: '60px' }}
                    >
                      <div className="flex items-center justify-between">
                         <span>{language === 'marathi' ? 'नं' : 'No'}</span>
                         <SortIcon columnKey="id" />
                      </div>
                    </th>
                    <th 
                      className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm cursor-pointer hover:bg-gray-50 transition-colors"
                      onClick={() => handleSort('name')}
                    >
                      <div className="flex items-center justify-between">
                         <span>{language === 'marathi' ? 'नाव' : 'Name'}</span>
                         <SortIcon columnKey="name" />
                      </div>
                    </th>
                    <th className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm text-center w-28 cursor-pointer hover:bg-gray-50 transition-colors">
                       <div className="flex items-center justify-center space-x-1">
                         <span>{language === 'marathi' ? 'प्रकार' : 'Type'}</span>
                         <ArrowUpDown className="w-4 h-4 text-gray-300 ml-1 inline" />
                       </div>
                    </th>
                    <th className="py-3 px-4 font-bold text-[#00008b] text-sm text-center w-44 cursor-pointer hover:bg-gray-50 transition-colors">
                       <div className="flex items-center justify-center space-x-1">
                         <span>{language === 'marathi' ? 'डाउनलोड करा' : 'Download'}</span>
                         <ArrowUpDown className="w-4 h-4 text-gray-300 ml-1 inline" />
                       </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {paginatedData.length > 0 ? (
                    paginatedData.map((item, index) => (
                      <tr 
                         key={item.id} 
                         className={`border-b border-gray-200 hover:bg-[#f8fafc] transition-colors ${index % 2 === 0 ? 'bg-[#fbfbfb]' : 'bg-white'}`}
                      >
                        <td className="py-2.5 px-4 text-sm text-gray-700 border-r border-gray-100 text-center font-medium">
                          {item.id}
                        </td>
                        <td className="py-2.5 px-4 text-sm text-[#4a729e] border-r border-gray-100">
                          {item.name}
                        </td>
                        <td className="py-2.5 px-4 text-center border-r border-gray-100">
                          <FileText className="w-5 h-5 text-blue-800 mx-auto opacity-75" />
                        </td>
                        <td className="py-2.5 px-4 text-center">
                          <button 
                            onClick={() => generatePDF(item)}
                            disabled={generatingId === item.id}
                            className={`text-white text-xs px-3 py-1.5 rounded-sm flex items-center justify-center mx-auto space-x-1 shadow-sm transition-all flex-nowrap w-32 ${
                              generatingId === item.id 
                                ? 'bg-gray-500 cursor-not-allowed' 
                                : 'bg-[#00a65a] hover:bg-[#008d4c]'
                            }`}
                          >
                            {generatingId === item.id ? (
                               <Loader className="w-3.5 h-3.5 animate-spin" />
                            ) : (
                               <Download className="w-3.5 h-3.5" />
                            )}
                            <span className="font-semibold whitespace-nowrap">
                              {generatingId === item.id ? 'Loading...' : 'View/Download'}
                            </span>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="py-6 text-center text-gray-500">
                        {language === 'marathi' ? 'कोणताही अर्ज सापडला नाही.' : 'No forms found.'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            <div className="flex justify-end items-center bg-gray-50 px-4 py-3 border-t border-gray-200">
              <div className="flex space-x-1 shadow-sm">
                <button 
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 px-3 py-1 text-sm rounded-l-sm disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Previous
                </button>
                
                {/* Dynamically generate page numbers */}
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => setCurrentPage(i + 1)}
                    className={`${
                      currentPage === i + 1 
                      ? 'bg-[#337ab7] text-white border-[#337ab7]' 
                      : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                    } border-y border-r px-3 py-1 text-sm`}
                  >
                    {i + 1}
                  </button>
                ))}

                <button 
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages || totalPages === 0}
                  className="bg-white border-y border-r border-gray-300 text-[#337ab7] hover:bg-gray-50 px-3 py-1 text-sm rounded-r-sm disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
};

export default PdfArjacheNamune;
